import { useTranslation } from 'react-i18next';
import { AppBar, AppBarContent } from '@commonClient2/components';
import { useAppLanguage } from '@hooks/index';
import { safeJsonParse } from '@commonClient2/services/json';
import { SessionStorageKeys } from '@enums/index'; 

const EmployeeAppBar = () => {
    const { t } = useTranslation('shiftBidding');
    const appLanguage = useAppLanguage();

    const configs = {
        appEnvironment: sessionStorage.getItem(SessionStorageKeys.appEnvironment) || '',
        appVersion: sessionStorage.getItem(SessionStorageKeys.version) || '',
        isMultiLanguage: safeJsonParse(sessionStorage.getItem(SessionStorageKeys.isMultiLanguage)) || false,
    };

    return (
        <AppBar>
            <AppBarContent
                name={t('common.pageName')}
                pageName={t('employee.common.employeeDashboard')}
                appLanguage={appLanguage}
                configs={configs}
            />
        </AppBar>
    );
};

export default EmployeeAppBar;
